<template>
  <form
    @submit.prevent="formDocsDispositivosAction"
    v-if="dispositivoId"
    class="mb-4"
  >
    <b-field horizontal>
      <b-table
        :data="documentos"
        striped
        hoverable
        style="border: 1px solid rgb(225, 225, 225)"
      >
        <b-table-column v-slot="doc" label="Tipo Documento" field="tipo">
          {{ doc.row.tipo }}
        </b-table-column>

        <b-table-column v-slot="doc" label="Data do Documento" field="data">
          {{ doc.row.data }}
        </b-table-column>

        <b-table-column
          v-slot="doc"
          label="Ações"
          custom-key="actions"
          cell-class="is-actions-cell"
          :width="100"
        >
          <div
            class="buttons is-right no-wrap"
            style="display: flex; justify-content: center"
          >
            <!-- DOWNLOAD -->
            <b-tooltip label="Baixar Documento" type="is-light">
              <b-button
                type="is-success"
                size="is-small"
                @click="downloadDocumento(doc.row)"
              >
                <b-icon icon="download" size="is-small" />
              </b-button>
            </b-tooltip>

            <!-- EXCLUIR -->
            <b-tooltip label="Excluir Documento" type="is-light">
              <b-button
                type="is-danger"
                size="is-small"
                @click="excluirDocumento(doc.row)"
              >
                <b-icon icon="delete" size="is-small" />
              </b-button>
            </b-tooltip>
          </div>
        </b-table-column>
        <div
          v-if="
            podeImprimirQRCode() &&
            $util.hasAnyRole(['ROLE_ADMIN', 'ROLE_CADASTRO'])
          "
          class="is-flex is-align-items-center is-justify-content-space-around mt-4"
          style="border-top: 1px solid #e1e1e1; padding-top: 15px"
        >
          <div>
            <strong>QR Code da Autorização</strong>
          </div>

          <b-tooltip label="Imprimir QR Code" type="is-light">
            <b-button type="is-primary" @click="imprimirQRCode">
              <b-icon icon="printer" size="is-small" />
              <span class="ml-2">Imprimir</span>
            </b-button>
          </b-tooltip>
        </div>

        <section slot="empty" class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>Não há dados&hellip;</p>
          </div>
        </section>
      </b-table>
    </b-field>
  </form>
</template>

<script>
import { defineComponent } from "vue";
import FilePicker from "@/components/FilePicker.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import DocumentoService from "@/services/DocumentoService";
import QRCode from "qrcode";
import DispositivosService from "@/services/DispositivosService";

export default defineComponent({
  name: "ListDocumentosDispositivos",
  components: {
    FilePicker,
    CardComponent,
  },
  props: {
    dispositivoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formDocsDispositivos: {
        file: null,
        data: null,
        tipo: null,
        idAcessoDispositivo: null, // Inicialize como null
      },
      isLoading: false,
      documentos: [
        {
          id: 1,
          tipo: "email",
          data: "2026-08-13",
          dataVencimento: null,
          nomeArquivo: "email-autorizacao.pdf",
        },
        {
          id: 2,
          tipo: "autorizacao",
          data: "2026-08-13",
          dataVencimento: null,
          nomeArquivo: "autorizacao-aparelho.pdf",
        },
      ],
      isAdmin: true,
      isCadastro: true,
      qrCode: null,
      isImprimindoQRCode: false,

      dispositivo: {
        status: "APROVADO",
        qrCodeToken: "TOKEN-MOCK-DISPOSITIVO-12345",
      },
      tiposDoc: [
        {
          label: "E-mail de autorização",
          valor: "email",
        },
        {
          label:
            "AUTORIZAÇÃO PARA UTILIZAÇÃO EXCEPCIONAL DE APARELHO ELETRÔNICO",
          valor: "autorizacao",
        },
      ],
    };
  },
  mounted() {
    const id = this.dispositivoId;
    console.log("ID DO ACESSO DISPOSITIVO:", id);
    if (id) {
      this.formDocsDispositivos.idAcessoDispositivo = id; // Defina o idAcessoPessoa aqui
      this.retrive(id);
    } else {
      this.$buefy.toast.open({
        message: "Erro: ID do acesso não encontrado!",
        position: "is-bottom",
        type: "is-danger",
      });
    }
  },
  methods: {
    async formDocsAction() {
      if (!this.validarDoc()) {
        return;
      }

      // Certifique-se de que idAcessoPessoa está definido
      if (!this.formDocsDispositivos.idAcessoDispositivo) {
        const id = this.acessoDispositivoId ?? this.$route.params.id;
        if (id) {
          this.formDocsDispositivos.idAcessoDispositivo = id;
        } else {
          this.$buefy.toast.open({
            message: "Erro: ID do acesso não encontrado!",
            position: "is-bottom",
            type: "is-danger",
          });
          return;
        }
      }

      try {
        this.isLoading = true;

        await DocumentoService.postDocumento(this.formDocsDispositivos);

        this.$buefy.toast.open({
          message: "Documentos Enviado com Sucesso!",
          position: "is-bottom",
          type: "is-success",
        });

        location.reload();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.response?.data?.message ?? "Erro ao enviar documento!",
          position: "is-bottom",
          type: "is-danger",
        });
        console.error("Erro ao enviar documentos:", error);
      } finally {
        this.isLoading = false;
      }
    },
    validarDoc() {
      if (!this.formDocsDispositivos.data) {
        this.$buefy.toast.open({
          message: "Erro, por favor preencha a Data corretamente!",
          position: "is-bottom",
          type: "is-danger",
        });
        return false;
      } else {
        if (this.formDocsDispositivos.data > new Date()) {
          this.$buefy.toast.open({
            message: "Erro, Data informada maior que data atual",
            position: "is-bottom",
            type: "is-danger",
          });
          return false;
        }
      }

      return true;
    },

    podeImprimirQRCode() {
      return (
        this.isAdmin &&
        this.isCadastro &&
        this.dispositivo.status === "APROVADO" &&
        !!this.dispositivo.qrCodeToken
      );
    },
    async imprimirQRCode() {
      try {
        this.isImprimindoQRCode = true;

        const id = this.$route.params.id;

        if (!id) {
          throw new Error("ID do dispositivo não encontrado.");
        }

        // Busca o token real no backend
        const response = await DispositivosService.getTokenDispositivo(id);

        const token = response.data.token;

        if (!token) {
          throw new Error("Token da autorização não encontrado.");
        }

        console.log("TOKEN PARA QR CODE:", token);

        // Gera o QR Code somente agora
        const qrCode = await QRCode.toDataURL(token);

        // Abre uma janela somente para impressão
        const janela = window.open("", "_blank");

        janela.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>QR Code - Autorização de Dispositivo</title>
          <style>
            body {
              margin: 0;
              padding: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              font-family: Arial, sans-serif;
            }

            img {
              width: 150px;
              height: 150px;
            }

            h2 {
              margin-bottom: 25px;
            }

            @media print {
              body {
                padding: 20px;
              }
            }
          </style>
        </head>

        <body>
          <h2>QR Code da Autorização</h2>
          <img src="${qrCode}" />

          <script>
            window.onload = function() {
              window.print();
            };
          <\/script>
        </body>
      </html>
    `);

        janela.document.close();

        console.log("QR Code enviado para impressão.");
      } catch (error) {
        console.error("Erro ao imprimir QR Code:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ??
            error.message ??
            "Não foi possível gerar o QR Code.",
          position: "is-bottom",
          type: "is-danger",
        });
      } finally {
        this.isImprimindoQRCode = false;
      }
    },

    downloadDocumento(item) {
      DocumentoService.baixarDoc(item.nomeArquivo).then((result) => {
        const blob = new Blob([result.data]);
        let url = window.URL.createObjectURL(blob);

        let extensao = item.nomeArquivo.split(".").pop();
        let nomeDoc = `doc-${item.tipo}.${extensao}`;

        const link = document.createElement("a");
        link.href = url;
        link.download = nomeDoc;
        link.click();

        window.URL.revokeObjectURL(url);
      });
    },
    async excluirDocumento(documento) {
      this.$buefy.dialog.confirm({
        title: "Excluir documento",
        message: "Tem certeza que deseja excluir este documento?",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            this.isLoading = true;

            await DocumentoService.deleteDocumento(documento.id);

            this.$buefy.toast.open({
              message: "Documento excluído com sucesso!",
              position: "is-bottom",
              type: "is-success",
            });

            await this.retrive(this.dispositivoId);
          } catch (error) {
            console.error("Erro ao excluir documento:", error);

            this.$buefy.toast.open({
              message:
                error.response?.data?.message ||
                "Não foi possível excluir o documento.",
              position: "is-bottom",
              type: "is-danger",
            });
          } finally {
            this.isLoading = false;
          }
        },
      });
    },
    async retrive(id) {
      try {
        console.log("Buscando documentos do dispositivo:", id);

        const result = await DocumentoService.getDocumentosAcessoDispositivo(
          id
        );

        console.log("Documentos retornados:", result);

        this.documentos = result.data ?? [];

        if (this.documentos.length === 0) {
          this.$emit("no-docs");

          this.$buefy.toast.open({
            message: "Nenhum documento encontrado!",
            position: "is-bottom",
            type: "is-info",
          });
        }
      } catch (error) {
        console.error("Erro ao buscar documentos:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ??
            "Não foi possível carregar os documentos.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
  },
});
</script>
